import { Article } from '@/modules/articles/model/article';

export default function embedLocationInXhtml(article: Article): string {
  if (!article.located?.trim()) {
    return article.body_xhtml;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(article.body_xhtml, 'text/html');

  const firstParagraph = doc.querySelector('p');
  if (firstParagraph) {
    const originalText = firstParagraph.innerHTML;
    const locatedText = `<span class='fst-italic'>${article.located}</span> - `;
    firstParagraph.innerHTML = locatedText + originalText;
  }

  return doc.body.innerHTML;
}
